import { Pipe, PipeTransform } from '@angular/core';
import { StepStatus } from '@shared/constants';
import { StepChallenge } from '@shared/factory';

@Pipe({
  standalone: true,
  name: 'stepStatus',
})
export class StepStatusPipe implements PipeTransform {
  transform(challenge: StepChallenge, index: number): StepStatus {
    const challengeTargets: number[] = challenge.targets;
    const stepTarget: number = challengeTargets[index];
    const nextStepTarget: number = challengeTargets[index + 1];
    const stepProgress: number = challenge.progress;

    if (stepProgress >= stepTarget && stepProgress < nextStepTarget) {
      return StepStatus.REACHED;
    }

    if (stepProgress >= stepTarget) {
      return StepStatus.DEFAULT;
    }

    return StepStatus.UNREACHED;
  }
}
